
<!-- <video  controls style="height: 144px;">
    <source [src]="safeSrc" type="video/mp4">
  Your browser does not support the video tag.
  </video>   -->
  <button (click)="openModal(template)" > open View  </button>

 
  <ng-template #template>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Video</h5>
        <button type="button" class="close" (click)="decline()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body" style="width: auto; height: auto;">
                <video  controls style="height: 144px;">
                  <source [src]="safeSrc" type="video/mp4">
                Your browser does not support the video tag.
                </video>  
      </div>
      
    </div>
    </ng-template>
  